import { render, staticRenderFns } from "./VLoader.vue?vue&type=template&id=b9b838d4&"
import script from "./VLoader.vue?vue&type=script&lang=js&"
export * from "./VLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports